import ContentManagmentApi from "@/services/api/contentManagmentApi.js";
import MiscApi from "../../services/api/misc";
const ContentManagmentApiService = new ContentManagmentApi();

const MiscApiService = new MiscApi();

export const homePageHelper = {
  methods: {
    fetchMapCollectionsToCarouselItems: async function () {
      try {
        const user = this.$session.getUserInfo();
        const [collectionsData, retailerData] = await Promise.all([
          ContentManagmentApiService.getCollectionsCarousel(),
          user.role === "RETAILER" ? MiscApiService.getMeRetailer() : Promise.resolve(),
        ]);

        const collections = collectionsData.data;
        const retailer = retailerData ? retailerData.data : null;

        return collections.map(({ entity_id, image_url, title, homepage_title }) => {
          return {
            title: title || homepage_title,
            imageUrl: image_url,
            id: entity_id,
            routerLinkTo: {
              name: "Collection",
              params: {
                collectionId: entity_id,
                collectionName: title || homepage_title,
              },
            },
            trackEventData: {
              action: "Perfect For The Collections Click",
              properties: {
                Location: "Homepage",
                "Collection Name": title || homepage_title,
                "Retailer Store Name": retailer ? retailer.store_name : " - ",
                "Retailer email": retailer ? retailer.email : " - ",
              },
            },
          };
        });
      } catch (error) {
        return [];
      }
    },
  },
};
